import React from 'react';

import ForumPostItem from '@components/FeedItems/ForumPostItem';
import UnitHeader from '@components/FeedItems/UnitHeader';
import useEventTracking from '@hooks/useEventTracking';
import { FeedUnit } from '@interfaces/homepage';
import { subscriber_directories_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';

interface ForumUnitProps {
  feedUnit: FeedUnit;
}

const ForumUnit = ({ feedUnit: { unitName, viewAllUrl, content } }: ForumUnitProps) => {
  const { Track, trackEvent } = useEventTracking({ location: TrackingLocation.ForumUnit });

  return (
    <Track>
      <div className="hidden border-0 border-b border-solid border-grayscale-gray px-16 py-32 sm:block sm:px-0 sm:py-48">
        <UnitHeader unitName={unitName} viewAllUrl={viewAllUrl} />
        <div className="grid grid-cols-3">
          {content.map((post) => (
            <ForumPostItem key={`${unitName}-${post.id}`} forumPost={post} />
          ))}
        </div>
      </div>
      <div className="border-0 border-b border-solid border-grayscale-gray px-16 py-32 sm:px-0 sm:py-48">
        <p className="mx-auto my-0 max-w-[330px] text-center font-suisse-neue text-body-md text-grayscale-gray xs:max-w-[640px] sm:text-body-lg">
          Search our community{' '}
          <a
            onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.Directory }))}
            href={subscriber_directories_path()}
            className="text-primary-magenta"
          >
            Directory
          </a>{' '}
          to engage with others who are serious about tech and business.
        </p>
      </div>
    </Track>
  );
};

export default ForumUnit;
